import { render, staticRenderFns } from "./AddressPropertyTypeRadioField.vue?vue&type=template&id=d971f828"
import script from "./AddressPropertyTypeRadioField.vue?vue&type=script&lang=js"
export * from "./AddressPropertyTypeRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports